<template>
    <o-form :title="$t('sandoz.sales_reallocation')" class="ortic-form-horizontal mb-10" ref="form"
            :url="'/api/sandoz/customer_match/' + $route.params.id">
        <template slot-scope="props">
            <b-row>
                <b-col>
                    <o-form-group :label="$t('sandoz.mst_customer_localkey_from')" class="d-none">
                        <b-input-group>
                            <input v-model="props.item.mst_customer_localkey_from" type="text" class="form-control">
                        </b-input-group>
                    </o-form-group>

                    <o-form-group :label="$t('sandoz.ean_from')" :class="props.item.ean_from_customer ? 'mb-1': ''">
                        <b-input-group>
                            <input v-model="props.item.ean_from" type="text" class="form-control"
                                   v-on:blur="customerName($event.target.value)" disabled>
                            <b-input-group-append>
                                <b-btn variant="primary" @click.prevent="show()">
                                    <fa icon="ellipsis-h"/>
                                </b-btn>
                            </b-input-group-append>
                        </b-input-group>
                    </o-form-group>


                    <o-form-group v-if="props.item.ean_from_customer" class="text-muted"
                                  :label="$t('sandoz.mst_customer_name')">
                        <b-input-group class="pt-1">
                            {{ props.item.ean_from_customer }}
                        </b-input-group>
                    </o-form-group>

                    <o-form-group :label="$t('sandoz.mst_customer_localkey_to')" class="d-none">
                        <b-input-group>
                            <input v-model="props.item.mst_customer_localkey_to" type="text" class="form-control">
                        </b-input-group>
                    </o-form-group>


                    <o-form-group :label="$t('sandoz.ean_to')" :class="props.item.ean_to_customer ? 'mb-1': ''">
                        <b-input-group>
                            <input v-model="props.item.ean_to" type="text" class="form-control"
                                   v-on:blur="customerName($event.target.value, 'to')" disabled>
                            <b-input-group-append>
                                <b-btn variant="primary" @click.prevent="show('to')">
                                    <fa icon="ellipsis-h"/>
                                </b-btn>
                            </b-input-group-append>
                        </b-input-group>
                    </o-form-group>
                    <o-form-group v-if="props.item.ean_to_customer" class="text-muted"
                                  :label="$t('sandoz.mst_customer_name')">
                        <b-input-group class="pt-1">
                            {{ props.item.ean_to_customer }}
                        </b-input-group>
                    </o-form-group>
                    <o-monthpicker :errorField="'valid_from'" :label="$t('sandoz.valid_from')"
                                   v-model="props.item.valid_from"/>
                    <o-monthpicker :errorField="'valid_to'" :label="$t('sandoz.valid_to')"
                                   v-model="props.item.valid_to"  day-of-the-month="last"/>
                </b-col>
                <b-col>
                    <o-textarea v-model="props.item.comment" :label="$t('sandoz.comment')"></o-textarea>
                </b-col>
            </b-row>
            <b-modal id="modal-ean" ref="addEanModel" :title="$t('sandoz.ean')" :ok-only="true" size="lg"
                     :ok-title="$t('core.cancel')">
                <o-table url="/api/sandoz/wholesaler_customer_master" title="" ref="eanList" :enable-new="false"
                         :enable-delete="false" :enable-edit="false" :shadow="false">
                    <template slot="filter">
                        <o-filter v-on:filter-updated="(filters) => $refs.eanList.setFilters(filters)">
                            <o-filter-text :title="$t('sandoz.ean')" column="ean"
                                           :show-button="true" :prepend-percentage="true">
                            </o-filter-text>
                            <o-filter-text :title="$t('sandoz.mst_customer_name')" column="mst_customer_name"
                                           :show-button="true" :prepend-percentage="true">
                            </o-filter-text>
                            <o-filter-text :title="$t('sandoz.mst_customer_address')" column="mst_customer_address"
                                           :show-button="true" :prepend-percentage="true">
                            </o-filter-text>
                            <o-filter-text :title="$t('sandoz.mst_customer_zip')" column="mst_customer_zip"
                                           :show-button="true"></o-filter-text>
                        </o-filter>
                    </template>
                    <template slot="head">
                        <th>{{$t('sandoz.ean')}}</th>
                        <th>{{$t('sandoz.mst_customer_name')}}</th>
                        <th>{{$t('sandoz.mst_customer_type')}}</th>
                        <th>{{$t('sandoz.mst_customer_address')}}</th>
                        <th>{{$t('sandoz.mst_customer_zip')}}</th>
                    </template>
                    <template slot="body" slot-scope="eanProps">
                        <td>{{ eanProps.item.ean }}</td>
                        <td>{{ eanProps.item.mst_customer_name }}</td>
                        <td>{{ eanProps.item.mst_customer_type }}</td>
                        <td>{{ eanProps.item.mst_customer_address }}</td>
                        <td>{{ eanProps.item.mst_customer_zip }}</td>
                    </template>
                    <template slot="body-controls" slot-scope="eanProps">
                        <td class="text-right">
                            <div class="btn-group btn-group-sm" role="group" aria-label="edit controls">
                                <b-btn variant="primary" @click="addEan(eanProps.item)">
                                    <fa icon="arrow-right"/>
                                </b-btn>
                            </div>
                        </td>
                    </template>
                </o-table>
            </b-modal>
        </template>
    </o-form>
</template>

<style lang="scss" scoped>
    .mb-10 {
        margin-bottom: 10rem;
    }
</style>

<script>
  import axios from 'axios'
  import {i18n} from '~/plugins/i18n'

  export default {
    data: () => ({
      type: 'from'
    }),
    methods: {
      show(type = 'from') {
        this.type = type
        this.$refs.addEanModel.show()
      },
      addEan(ean) {
        if(this.type === 'to') {
          this.$set(this.$refs.form.item, 'mst_customer_localkey_to', ean.mst_customer_localkey)
          this.$set(this.$refs.form.item, 'ean_to', ean.ean)
          this.$set(this.$refs.form.item, 'ean_to_customer', ean.mst_customer_name)
        } else {
          this.$set(this.$refs.form.item, 'mst_customer_localkey_from', ean.mst_customer_localkey)
          this.$set(this.$refs.form.item, 'ean_from', ean.ean)
          this.$set(this.$refs.form.item, 'ean_from_customer', ean.mst_customer_name)
        }
        this.$refs.addEanModel.hide()
      },
      customerName(value, from = 'from') {
        if(!value) {
          if(from === 'to') {
            this.$set(this.$refs.form.item, 'ean_to_customer', null)
          } else {
            this.$set(this.$refs.form.item, 'ean_from_customer', null)
          }
          return
        }

        var url = '/api/sandoz/wholesaler_customer_master?filter[ean]=' + value
        axios
          .get(url)
          .then((response) => {
            if(from === 'to') {
              this.$set(this.$refs.form.item, 'ean_to_customer',
                  response.data.data[0] ? response.data.data[0].mst_customer_name : null
              )
            } else {
              this.$set(this.$refs.form.item, 'ean_from_customer',
                  response.data.data[0] ? response.data.data[0].mst_customer_name : null
              )
            }
          })
          .catch((error) => {})
      }
    }
  }
</script>
